export default {
	account: {
		title: "Kontoeinstellungen",
		sections: {
			profile: "Profil",
			invitations: "Einladungen",
			security: "Sicherheit",
			privacy: "Datenschutz & Speicher",
		},
		profile: {
			color: "Farbe",
			managedByProvider:
				"Name und E-Mail werden in Ihrem Konto verwaltet. Hier lassen sich nur Sprache und Farbe ändern.",
			title: "Profil",
			emailConfirmed: "E-Mail bestätigt",
			emailNotConfirmed: "E-Mail nicht bestätigt",
			save: "Änderungen speichern",
			updated: "Profil aktualisiert.",
			failed: "Das Profil konnte nicht aktualisiert werden.",
		},
		security: {
			title: "Anmeldung und Sicherheit",
			description:
				"Passwort, Zwei-Faktor-Authentifizierung und Passkeys verwalten Sie in Ihrem Konto.",
			manage: "Sicherheitseinstellungen verwalten",
		},
		pats: {
			title: "Persönliche Zugriffstoken",
			description:
				"Persönliche Zugriffstoken geben Skripten und CI-Jobs unbeaufsichtigten Zugriff auf Notitia. " +
				"Jedes Token ist auf die Berechtigungen beschränkt, die Sie für bestimmte Projekte oder " +
				"Dataspaces wählen, und gewährt nie serverweiten Zugriff.",
			empty: "Sie haben noch keine persönlichen Zugriffstoken erstellt.",
			actions: {
				create: "Token erstellen",
			},
			revoke: {
				title: "Dieses Token widerrufen?",
				body: "Alles, was das Token \u201E{name}\u201C verwendet, verliert sofort den Zugriff. Dies lässt sich nicht rückgängig machen.",
			},
			create: {
				title: "Persönliches Zugriffstoken erstellen",
			},
			secret: {
				usage:
					"Zum Verwenden tauschen Sie es, wie unten gezeigt, bei diesem Server gegen ein " +
					"Zugriffstoken. Senden Sie dieses Zugriffstoken als Bearer-Token bei Ihren " +
					"API-Aufrufen. Das Zugriffstoken läuft nach wenigen Minuten ab; tauschen Sie " +
					"dann erneut.",
			},
			revoked: "Token widerrufen.",
			error: {
				pat_lifetime_exceeded: "Ein Token kann höchstens 90 Tage gültig sein.",
				pat_name_invalid: "Der Name muss 1 bis 100 Zeichen lang sein.",
				pat_grants_invalid: "Wählen Sie zwischen 1 und 100 Berechtigungen.",
				pat_grant_not_held:
					"Sie besitzen eine der gewählten Berechtigungen nicht mehr. Laden Sie die Liste neu und wählen Sie erneut.",
				pat_mint_refused:
					"Der Kontodienst hat die Ausstellung des Tokens abgelehnt. Versuchen Sie es in Kürze erneut.",
				idp_unavailable:
					"Der Kontodienst ist derzeit nicht erreichbar. Versuchen Sie es in Kürze erneut.",
				pat_not_allowed:
					"Persönliche Zugriffstoken lassen sich nicht mit einem Token verwalten.",
				missing_entitlement: "Ihre Rolle erlaubt keine Token, die nie ablaufen.",
				pat_mint_mismatch:
					"Der Kontodienst hat das Token mit einem anderen Ablaufdatum ausgestellt als " +
					"angefordert, deshalb wurde es sofort widerrufen. Melden Sie das einer " +
					"Administratorin oder einem Administrator.",
				generic: "Etwas ist schiefgelaufen. Versuchen Sie es erneut.",
			},
		},
		privacy: {
			title: "Lokale Daten",
			description:
				"Was Notitia auf diesem Gerät ablegt, gelesen aus derselben Tabelle, durch die " +
				"die App schreibt — diese Liste kann also nicht von dem abweichen, was " +
				"tatsächlich gespeichert ist.",
			notice: {
				noTracking:
					"Keine Tracking-Cookies, kein Tracking durch Dritte, keine Analyse. Notitia " +
					"setzt nur die Cookies, die die Anmeldung braucht (unten aufgeführt), lädt " +
					"keine Analyse- oder Fehlerberichtsskripte und bindet nichts aus Werbe- " +
					"oder sozialen Netzwerken ein.",
				externalHosts:
					"Außerhalb dieser Installation erreicht die App zwei Hosts. " +
					"auth.livereader.com ist der Kontodienst von LiveReader: Zum An- und " +
					"Abmelden wird Ihr Browser dorthin weitergeleitet (ist die stille Anmeldung " +
					"eingeschaltet, auch bei jedem Aufruf ohne Sitzung), und der Notitia-Server fragt " +
					"dort Ihr Profil ab. Was der Kontodienst speichert, steht unten unter „Beim " +
					"Kontodienst“. cdn.graphly.dev liefert die Diagramm-Vorlagen, die ein Projekt " +
					"verwenden kann, und läuft auf derselben Infrastruktur wie der Rest von " +
					"Notitia. Beide betreibt LiveReader selbst; keiner von beiden ist also eine " +
					"Übermittlung an Dritte.",
				scope:
					"Darüber hinaus legt Notitia auf diesem Gerät nur ab, was die Tabellen " +
					"unten zeigen.",
				legal: "Unternehmensangaben, Impressum und Datenschutzerklärung finden Sie unter",
			},
			table: {
				key: "Schlüssel",
				purpose: "Kategorie",
				what: "Wofür",
				size: "Größe",
			},
			purposes: {
				essential: "Erforderlich",
				preference: "Einstellung",
				viewState: "Ansichtszustand",
			},
			scopes: "{count} Eintrag | {count} Einträge",
			entries: {
				storageVersion:
					"Hält fest, welches Schlüsselschema dieses Gerät verwendet, damit die " +
					"einmalige Umbenennung der älteren Schlüssel genau einmal läuft.",
				pendingInvitation:
					"Die Einladung, für die Sie „Zum Annehmen anmelden“ gewählt haben, damit die " +
					"nächste Anmeldung auf diesem Gerät sie öffnet, auch wenn Sie dazwischen erst " +
					"ein Konto anlegen. Wird beim Öffnen gelöscht, spätestens nach einem Tag ignoriert.",
				themeMode: "Hell, dunkel oder der Systemeinstellung folgend.",
				locale: "Die von Ihnen gewählte Sprache.",
				logHeight: "Höhe der Log-Leiste eines Prozesses.",
				operatorPanelSplits:
					"Wie die Spalten und Zeilen einer Prozessansicht aufgeteilt sind, so wie Sie sie gezogen haben, je Art von Prozess.",
				envNameColWidth:
					"Breite der Namensspalte bei den Umgebungsvariablen eines Dataspace.",
				processOverviewWidth: "Breite des Übersichts-Panels im Prozesseditor.",
				processPropertiesWidth: "Breite des Eigenschaften-Panels im Prozesseditor.",
				actionPaletteWidth: "Breite der Aktionspalette im Aktivitätseditor.",
				actionPropertiesWidth: "Breite des Eigenschaften-Panels im Aktivitätseditor.",
				dataobjectListWidth: "Breite der Datenobjektliste im Modelleditor.",
				dataobjectPropertiesWidth: "Breite des Eigenschaften-Panels im Modelleditor.",
				typePropertiesWidth: "Breite des Eigenschaften-Panels auf der Typenseite.",
				processSidebarSide: "An welcher Kante der Prozesseditor seine Panels andockt.",
				actionSidebarSide: "An welcher Kante der Aktivitätseditor seine Panels andockt.",
				dataobjectSidebarSide: "An welcher Kante der Modelleditor seine Panels andockt.",
				sidebarAutoCollapse:
					"Ob beim Öffnen eines Panels die dahinterliegenden eingeklappt werden.",
				processOverviewCollapsed:
					"Ob Sie den Übersichts-Panel des Prozesseditors eingeklappt haben.",
				actionPaletteCollapsed:
					"Ob Sie die Aktionspalette des Aktivitätseditors eingeklappt haben.",
				dataobjectListCollapsed:
					"Ob Sie die Datenobjektliste des Modelleditors eingeklappt haben.",
				processSidebarSort:
					"Wie der Prozesseditor seine Datenobjektliste sortiert und filtert.",
				processAvailableSort:
					"Wie der Prozesseditor die zum Hinzufügen verfügbaren Datenobjekte sortiert.",
				projectSearch: "Ihre Suche in der Projektliste.",
				dataspaceSearch: "Ihre Suche in der Dataspace-Liste.",
				processListSearch: "Ihre Suche in der Prozessliste eines Projekts, je Projekt.",
				activityListSearch:
					"Ihre Suche in der Aktivitätenliste eines Projekts, je Projekt.",
				typeListSearch: "Ihre Suche in der Datentypliste eines Projekts, je Projekt.",
				terminologySearch:
					"Ihre Suche in der Terminologieliste eines Projekts, je Projekt.",
				dataobjectViewsSearch:
					"Ihre Suche in der Ansichtsliste eines Projekts, je Projekt.",
				dataobjectListSearch:
					"Ihre Suche in der Datenobjekttabelle eines Projekts, je Projekt.",
				processDataobjectSearch:
					"Ihre Suche in der Datenobjektliste des Prozesseditors, je Prozess.",
				modelSidebarSearch:
					"Ihre Suche in der Datenobjektliste des Modelleditors, je Ansicht.",
				processSidebarTab:
					"Auf welchem Tab die Seitenleiste des Prozesseditors stand, je Prozess.",
				projectHomeTab: "Ob zuletzt Übersicht oder Einstellungen geöffnet war, je Projekt.",
				projectHomeSection: "Welcher Einstellungsbereich zuletzt offen war, je Projekt.",
				dataobjectsTab:
					"Ob zuletzt Ansichten oder Datenobjekte geöffnet waren, je Projekt.",
				dataobjectListRows:
					"Ob die Datenobjekttabelle zuletzt Datenobjekte oder ihre Attribute zeigte, je Projekt.",
				operatorPanelTabs:
					"Welches Panel jeder Platz einer Prozessansicht zeigte, wo sich Panels einen Platz als Tabs teilen, je Prozess.",
				viewListSort: "Wie Sie die Ansichtsliste eines Projekts sortieren.",
				processListSort: "Wie Sie die Prozessliste eines Projekts sortieren.",
				activityListSort: "Wie Sie die Aktivitätenliste eines Projekts sortieren.",
				activityListGrouping:
					"Wie Sie die Aktivitätenliste eines Projekts gruppieren, je Projekt.",
				activityListFolded:
					"Welche Abschnitte der Aktivitätenliste eines Projekts Sie eingeklappt haben, je Projekt.",
				typeListSort: "Wie Sie die Datentypliste eines Projekts sortieren.",
				dataobjectListSort: "Wie Sie die Datenobjekttabelle eines Projekts sortieren.",
				terminologySort: "Wie Sie die Terminologieliste eines Projekts sortieren.",
				recentViews:
					"Die zuletzt geöffneten Ansichten, je Projekt, für die Sortierung nach zuletzt geöffnet.",
				recentProcesses:
					"Die zuletzt geöffneten Prozesse, je Projekt, für die Sortierung nach zuletzt geöffnet.",
				recentActivities:
					"Die zuletzt geöffneten Aktivitäten, je Projekt, für die Sortierung nach zuletzt geöffnet.",
				recentTypes:
					"Die zuletzt geöffneten Datentypen, je Projekt, für die Sortierung nach zuletzt geöffnet.",
				recentDataobjects:
					"Die zuletzt geöffneten Datenobjekte, je Projekt, für die Sortierung nach zuletzt geöffnet.",
			},
			actions: {
				clearViewState: "Ansichtszustand löschen",
				clearViewStateHint: "Suchbegriffe, Filter, Sortierung und offene Tabs.",
				clearPreferences: "Einstellungen löschen",
				clearPreferencesHint:
					"Erscheinungsbild, Sprache und Panel-Aufteilung. Die Seite wird neu " +
					"geladen, damit die Oberfläche auf die Standardwerte zurückfällt.",
			},
			cleared: {
				viewState: "Suchbegriffe, Filter und Tab-Zustand gelöscht.",
				app: "Offline-Unterstützung von diesem Gerät entfernt.",
			},
			signOutNote:
				"Beim Abmelden werden Ihre Sitzung und Ihr Ansichtszustand automatisch " +
				"gelöscht. Einstellungen bleiben erhalten, damit die App beim nächsten Mal " +
				"so aussieht, wie Sie sie verlassen haben.",
			cookies: {
				title: "Cookies",
				description:
					"Vom Notitia-Server gesetzt und nur für die Anmeldung da. Sie sind HttpOnly, " +
					"also für kein Skript lesbar, auch nicht für Notitia selbst, und werden nur " +
					"an die Anmeldeadressen von Notitia gesendet.",
				table: {
					name: "Name",
					what: "Wofür",
					lifetime: "Gültigkeit",
				},
				entries: {
					session: {
						what:
							"Eine zufällige Kennung Ihrer Sitzung und sonst nichts. Alles Weitere " +
							"bleibt auf dem Server.",
						lifetime:
							"Bis zum Abmelden. Die Sitzung endet nach 8 Stunden ohne Nutzung, " +
							"spätestens nach 12 Stunden, und wenn der Server neu startet.",
					},
					login: {
						what:
							"Verknüpft eine begonnene Anmeldung mit diesem Browser, damit niemand " +
							"anderes sie abschließen kann. Eines je laufender Anmeldung, damit sich " +
							"gleichzeitig anmeldende Tabs nicht gegenseitig ersetzen.",
						lifetime:
							"Höchstens 10 Minuten. Wird gelöscht, sobald die Anmeldung fertig ist.",
					},
				},
			},
			app: {
				title: "Installierte App und Offline-Seite",
				description:
					"Sobald Sie angemeldet sind, richtet Ihr Browser für Notitia einen kleinen " +
					"Helfer ein, einen Service Worker. Er zeigt eine Offline-Seite, wenn der " +
					"Server nicht erreichbar ist, und meldet, wenn eine neue Version verfügbar " +
					"ist. Er liest und speichert nichts von dem, was Sie in der App tun, und " +
					"beantwortet nie eine Anfrage aus einer eigenen Kopie. Die Installation von " +
					"Notitia als App erfolgt über das Menü Ihres Browsers und speichert nichts weiter.",
				entries: {
					worker: {
						what:
							"Zeigt die Offline-Seite, wenn der Server nicht erreichbar ist, und " +
							"bemerkt neue Versionen. Er wirkt nur auf die eigenen Seiten von Notitia.",
						lifetime:
							"Bis Sie ihn hier entfernen oder die Daten dieser Website im Browser " +
							"löschen. Er wird wieder eingerichtet, sobald Sie Notitia das nächste Mal " +
							"angemeldet öffnen.",
					},
					cache: {
						what:
							"Die Offline-Seite mit Skript, Stylesheet und Logo: für alle dieselben " +
							"Dateien, nichts über Sie. Benannt nach der Version, zu der sie gehört.",
						lifetime:
							"Wird mit jeder neuen Version ersetzt und zusammen mit dem Helfer entfernt.",
					},
				},
				clear: "Offline-Unterstützung entfernen",
				clearHint:
					"Entfernt den Helfer und seinen Cache von diesem Gerät. Sobald Sie Notitia " +
					"das nächste Mal angemeldet öffnen, ist er wieder da.",
			},
			stored: {
				title: "Auf Servern gespeichert",
				server: {
					title: "Auf dem Notitia-Server",
					intro:
						"Notitia speichert keine Passwörter, Zwei-Faktor-Geheimnisse oder Passkeys: " +
						"Die Anmeldung übernimmt der Kontodienst. Auf diesem Server liegen:",
					items: {
						profile:
							"Ihr Profil, wie es der Kontodienst bei der Anmeldung meldet: Kennung, " +
							"E-Mail-Adresse und ob sie bestätigt ist, Name. Dazu Ihre Sprache, Ihre " +
							"Farbe und Ihre Systemrolle.",
						memberships:
							"Ihre Mitgliedschaften und Rollen in Projekten und Dataspaces, " +
							"Einladungen, die Sie verschickt oder angenommen haben, und was Sie " +
							"angelegt haben.",
						tokens:
							"Zu jedem persönlichen Zugriffstoken Name, Berechtigungen sowie Erstellungs-, " +
							"Ablauf- und Widerrufsdatum. Das Token selbst wird nicht gespeichert.",
						session:
							"Ihre Sitzung, nur im Arbeitsspeicher: die Token des Kontodienstes für " +
							"Ihre Anmeldung. Sie verschwindet beim Abmelden, nach Ablauf und wenn " +
							"der Server neu startet.",
					},
				},
				provider: {
					title: "Beim Kontodienst",
					intro:
						"Angemeldet wird über den Kontodienst von LiveReader, einen eigenen Dienst " +
						"mit eigener Datenhaltung. Was dort liegt, verwalten Sie in Ihrem Konto " +
						"beim Kontodienst, nicht hier. Er speichert:",
					items: {
						account:
							"Ihr Konto: Anmeldename (Ihre E-Mail-Adresse), Name, Sprache und das " +
							"Passwort als Argon2id-Hash.",
						factors:
							"Ihre zweiten Faktoren: das TOTP-Geheimnis, die Wiederherstellungscodes " +
							"als Hash und Ihre Passkeys.",
						sessions:
							"Ihre Anmeldesitzungen und Geräte, jeweils mit IP-Adresse und " +
							"Browserkennung (User-Agent). Abgelaufene Sitzungen werden stündlich " +
							"gelöscht.",
						audit:
							"Ein Sicherheitsprotokoll Ihrer Anmeldungen und Kontoänderungen mit " +
							"IP-Adresse und Browserkennung, bei fehlgeschlagenen Anmeldungen auch " +
							"mit dem eingegebenen Namen. Für dieses Protokoll ist derzeit keine " +
							"Löschfrist festgelegt.",
						consents:
							"Welchen Anwendungen Sie welchen Zugriff erlaubt haben, und Ihre " +
							"persönlichen Zugriffstoken beim Kontodienst (das Geheimnis nur als HMAC).",
						shared:
							"An Notitia gibt er bei der Anmeldung Ihre Kennung, Ihre E-Mail-Adresse " +
							"und deren Bestätigungsstatus, Ihren Namen und Ihre Notitia-Systemrolle " +
							"weiter, beim Abmelden eine Abmeldenachricht.",
						cookies:
							"In Ihrem Browser setzt er auf seiner eigenen Adresse eigene Cookies: die " +
							"Anmeldesitzung (bis zum Schließen des Browsers, mit „Angemeldet " +
							"bleiben“ bis zu 30 Tage), eine Gerätekennung (400 Tage), einen Schutz " +
							"vor fremden Anfragen (CSRF), eine Kennung für eine laufende Anmeldung " +
							"(1 Stunde) und für sein eigenes Kontoportal ein Erneuerungstoken.",
						mail:
							"E-Mails, etwa zur Bestätigung Ihrer Adresse, verschickt er über einen " +
							"E-Mail-Server; zugestellte Nachrichten löscht er standardmäßig nach " +
							"7 Tagen. Analyse, Captchas oder weitere Dienste Dritter nutzt er nicht.",
					},
				},
			},
			elsewhere: {
				title: "Woanders abgelegt und von hier nicht löschbar",
				passkey:
					"Ein Passkey wird von Ihrem Betriebssystem oder Sicherheitsschlüssel " +
					"gespeichert, nie von Notitia. Passkeys registrieren und entfernen Sie in " +
					"Ihren Sicherheitseinstellungen beim Kontodienst; vom Gerät löschen Sie " +
					"ihn in den Passworteinstellungen Ihres Systems.",
				cache:
					"Ihr Browser legt die Skripte, Stylesheets und Schriften dieser App im Cache ab. " +
					"Ein Leeren des Browser-Caches entfernt diese.",
			},
		},
	},
};
